import React from 'react'

export default class QuoteBox extends React.Component {
    render() {
        return (
            <div className="quote-box" style={{color: '#f6e7e6'}}>
                <h4 className="font-satisfy" style={{fontSize: '40px', textAlign: 'left'}}>{this.props.reviewTitle}</h4>
                <h5 className="font-satisfy" style={{fontSize: '25px', textAlign: 'left'}}>{this.props.reviewSubtitle}</h5>
                <h6 className="font-josefin" style={{textAlign: 'left'}}>{this.props.reviewSource}</h6>
                <div style={{height: '20px'}}/>
                <p className="font-josefin" style={{fontSize: '20px'}}>{this.props.reviewText}</p>
            </div>
        );
    }
}